/**
 * Entry Point Webpack
 */
import "core-js/stable";
import "regenerator-runtime/runtime";

import "jquery";
import "lodash";
// other global deps
import angular from "angular";
import "angular-resource";
import "angular-ui-select";
import "angular-sanitize";
import "angular-simple-logger";
import "angular-route";
import "angular-ui-sortable";
import "ui-leaflet";
import "angular-qr-scanner";
import "angular-toastr";
import "angular-animate";
import "ngprogress/build/ngProgress.min";
import "angular-bootstrap-toggle-switch";

import "angular-img-cropper/dist/angular-img-cropper.min";
import "ngstorage";
import "angular-chart.js";
import "checklist-model";

import "../vendor/ui-bootstrap-tpls.min";
import "jquery-ui";
import "angular-datatables";


import "raven-js/dist/raven";
import "raven-js/dist/plugins/angular";

// Initialisation manuelle de Leaflet comme référence commune L.XXX
import L from "leaflet";
import "leaflet.markercluster/dist/leaflet.markercluster";
import "Leaflet.draw/dist/leaflet.draw";
import "Leaflet.EasyButton";
import "Leaflet.extra-markers";
import "leaflet.awesome-markers";
import "leaflet-dialog";
import "leaflet-fullscreen/dist/Leaflet.fullscreen.min";
import "leaflet-polylinedecorator";
import "leaflet-routing-machine";
import "leaflet-plugins/layer/Marker.Rotate";
// import app modules
import "../common/services/services";
import "./e-iti/index";
import "./admin/index";
import "./carto-iti/index";
import "./open-iti/index";
import "./manager/index";
import "./coherence/index";
import "./data-management/index";
import "./templates";


// Directives import
import "../common/index";
import "../common/templates";

// window.Webcam = Webcam

window.L = L;

// window.React = React;

// CSS Imports
require("../styles/project.less");

require("../../node_modules/angular-datatables/dist/css/angular-datatables.min.css");
require("../../node_modules/angular-datatables/dist/plugins/bootstrap/datatables.bootstrap.min.css");
require("../../node_modules/select2/dist/css/select2.min.css");
require("../../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css");
require("../../node_modules/ngprogress/ngProgress.css");
require("../../node_modules/angular-toastr/dist/angular-toastr.min.css");
require("../../node_modules/angular-bootstrap-toggle-switch/dist/css/bootstrap3/bootstrap-switch.min.css");
require("../../node_modules/bootstrap-horizon/bootstrap-horizon.css");
require("../../node_modules/angular-ui-select/dist/select.min.css");
require("../../node_modules/leaflet/dist/leaflet.css");
require("../../node_modules/Leaflet.EasyButton/src/easy-button.css");
require("../../node_modules/leaflet-fullscreen/dist/leaflet.fullscreen.css");
require("../../node_modules/leaflet-dialog/Leaflet.Dialog.css");
require("../../node_modules/leaflet.markercluster/dist/MarkerCluster.css");
require("../../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css");
require("../../node_modules/Leaflet.extra-markers/dist/css/leaflet.extra-markers.min.css");
require("../../node_modules/leaflet.awesome-markers/dist/leaflet.awesome-markers.css");
require("../../node_modules/leaflet-routing-machine/dist/leaflet-routing-machine.css");
require("../../node_modules/Leaflet.draw/dist/leaflet.draw.css");
// END CSS Imports

/**
 Modules dependencies
 */
let application = angular.module("application", [
	"coherence",
	"carto-iti",
	"open-iti",
	"admin",
	"manager",
	"data-management",
	"exploitation",
    "app",
	"services",
	"angular-img-cropper",
	//"camera",
	"chart.js",
	"checklist-model",
	"config",
	"datatables",
	"datatables.bootstrap",
	"datatables.columnfilter",
	"datatables.colvis",
	"mhicauber.tch-selectable-row", // select a row in a table adds css class
	"ngAnimate",
	"ngResource",
	"ngProgress", // top screen progress bar
	"ngRoute", // to configure routing
	"ngSanitize",
	"ngStorage",
	"toastr", // toast notifications
	"toggle-switch",
	"ui.bootstrap",
	"ui-leaflet",
	"ui.select"
]);

export default application;
